<div class="card">
    <div class="card-header">
        <label class="control-label" paflabel="Recapitulatif"></label>
    </div>
    <div class="card-body">
        <div class="d-flex flex-column justify-content-start align-items-space-around">
            <label class="control-label text-primary" paflabel="Verification_de_vos_informations"></label>
            <label class="control-label " paflabel="Derniere_etape_Verificationn_info"></label>
            <div class="row" id="recapitulatif">
                <div class="col-6">
                    <ul>
                        <li>
                            <label class="control-label" paflabel="Descriptif"></label>
                            <ul>
                                <li>
                                    <span paflabel="Raison_sociale"></span> : {{supplier.SupplierName}}
                                </li>
                                <li *ngIf="supplier.GroupName">
                                    <span paflabel="Nom_du_groupe"></span> : {{supplier.GroupName}}
                                </li>
                                <li>
                                    <span paflabel="Forme_juridique"></span> : {{supplier.LegalForm?.LblCod}}
                                </li>
                                <li *ngIf="supplier.Siret">
                                    <span paflabel="Siret"></span> : {{supplier.Siret}}
                                </li>
                                <li *ngIf="supplier.TvaIntra">
                                    <span paflabel="Intratva"></span> : {{supplier.TvaIntra}}
                                </li>
                                <li *ngIf="supplier.Rsa">
                                    <span paflabel="Rsa"></span> : {{supplier.Rsa}}
                                </li>
                                <li *ngIf="supplier.Duns">
                                    <span paflabel="Duns"></span> : {{supplier.Duns}}
                                </li>
                                <li>
                                    <span paflabel="Adresse"></span> : {{displayAddressSupplier()}}
                                </li>
                                <li *ngIf="supplier.ApeCod">
                                    <span paflabel="Activite_Code_NAF_ou_APE"></span> : {{supplier.ApeCod?.Cod}} -
                                    {{supplier.ApeCod?.LblCod}}
                                </li>
                                <li *ngIf="supplier.WebSite">
                                    <span paflabel="Site_Web"></span> : {{supplier.WebSite}}
                                </li>
                                <li>
                                    <span paflabel="Demandeur"></span> : {{supplier.InternalContactFirstname}}  {{supplier.InternalContactLastname}} - {{InternalContactDisplayedMail}}
                                </li>
                                <li>
                                    <span paflabel="Contact_de_reference"></span> :
                                    {{contactReferent.Civility?.Cod}}
                                    {{contactReferent.Firstname}} {{contactReferent.Lastname}} - <span
                                        paflabel="Email">
                                    </span>: <strong>{{contactReferentDisplayedMail}}</strong>
                                </li>
                                <li *ngIf="otherContacts.length==1">
                                    <span>
                                        <label *ngIf="otherContacts.length>0" paflabel="Autre_contact"></label> :
                                        {{otherContacts[0].Civility?.Cod}} {{otherContacts[0].Firstname}}
                                        {{otherContacts[0].Lastname}} {{otherContacts[0].Email}}
                                    </span>
                                    <span *ngIf="otherContacts.length>1">
                                        <label paflabel="Autres_contacts"></label> :
                                        <ul>
                                            <li *ngFor="let c of otherContacts">
                                                {{c.Civility?.Cod}} {{c.Firstname}} {{c.Lastname}} {{c.Email}}
                                            </li>
                                        </ul>
                                    </span>
                                </li>
                                <li *ngIf="supplier.HQSiret">
                                    <span paflabel="Num_SIRET_Siege"></span> : {{supplier.HQSiret}}
                                </li>
                                <li *ngIf="otherAgencies.length>0">
                                    <label paflabel="Nombre_d_agences"></label> : {{otherAgencies.length}}
                                </li>
                                <!-- 
                            <li>
                                <span paflabel=""></span> : {{}}
                            </li>
                            <li>
                                <span paflabel=""></span> : {{}}
                            </li>
                            <li>
                                <span paflabel=""></span> : {{}}
                            </li> -->
                            </ul>
                        </li>

                    </ul>
                    <ul>
                        <li>
                            <label class="control-label" paflabel="Informations_comptables"></label>
                            <ul>
                                <li>
                                    <span paflabel="Devise_de_commande"></span> : {{supplier.OrderCurrency?.Cod}}
                                </li>
                                <li>
                                    <span paflabel="Langue_utilisee_avec_le_fournisseur"></span> : {{supplier.LngCod}}
                                </li>
                                <li *ngIf="supplier.TopAffacturage">
                                    <span paflabel="Societe_d_affacturage"></span> : {{supplier.AffacturageName}}
                                    -
                                    <span paflabel="Siret"></span>: {{supplier.AffacturageSiret}}
                                </li>
                                <li *ngIf="this.supplier.AddrFacId">
                                    <span paflabel="Adresse_de_facturation"></span> :
                                    {{displayAddressAffacturage()}}
                                </li>
                                <li>
                                    <span paflabel="Dematerialisation_des_factures"></span> :
                                    <span paflabel="Oui" *ngIf="supplier.TopFacDemat == 1"></span>
                                    <span paflabel="Non" *ngIf="supplier.TopFacDemat != 1"></span>
                                    <ul *ngIf="supplier.TopFacDemat == 1">
                                        <li>
                                            <span paflabel="Adresse_mail_pour_l_envoi_des_factures"></span> :
                                            {{supplier.FacSendEmail}}
                                        </li>
                                        <li>
                                            <span paflabel="Adresse_mail_pour_le_retour_des_factures_2"></span> :
                                            {{supplier.FacReturnEmail}}
                                        </li>
                                        <li>
                                            <span paflabel="Adresse_mail_envoi_d_avis_de_virement"></span> :
                                            {{supplier.PaySendEmail}}
                                        </li>
                                    </ul>
                                </li>
                            </ul>

                        </li>
                    </ul>
                </div>
                <div class="col-6">
                    <ul>
                        <li>
                            <label class="control-label" paflabel="Savoir_faire"></label>
                            <ul>
                                <li>
                                    <span paflabel="Coeur_de_metier"></span> : {{mainFamilyLabel()}}
                                </li>
                                <li *ngIf="supplierAnswers.length>0">
                                    <span paflabel="Specificites"></span> :
                                    <ul>
                                        <li *ngFor="let a of supplierAnswers">
                                            <span  [paflabel]="a.Question.LblCod"></span> :
                                            <span paflabel="Oui" *ngIf="a.Answer == 1"></span>
                                            <span paflabel="Non" *ngIf="a.Answer == 0"></span>

                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    <span paflabel="Competences"></span> :
                                    <ul style="max-height: 200px; overflow-y: scroll;">
                                        <li *ngFor="let f of supplier.SupplierFamilies">
                                            {{familyNodeLabel(f.FamilyId)}}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>